<template>
    <div class="poplogin">
        <div class="loginlogo"><img :src="$store.state.logourl" /></div>
        <dl>
            <dd class="input"><el-input :class="{iserr:iserrusername}" @focus="iserrusername=false" v-model="logininfo.username" :placeholder="wtype==1?$common.dicword('usernamemobile'):$common.dicword('mobile')"><i slot="prepend" class="iconfont icon-ziyuanxhdpi"></i></el-input></dd>
            <dd v-if="wtype==1" class="input"><el-input :class="{iserr:iserrpwd}" @focus="iserrpwd=false" v-model="logininfo.pwd" show-password :placeholder="$common.dicword('pwd')"><i slot="prepend" class="iconfont icon-ziyuanxhdpi1"></i></el-input></dd>
            <dd v-else class="input"><div class="vcode"> <el-input :class="{iserr:iserrvcode}" @focus="iserrvcode=false" v-model="logininfo.vcode" maxlength="6" :placeholder="$common.dicword('vcode')"><i slot="prepend" class="iconfont icon-ziyuanxhdpi1"></i></el-input></div><div class="vcodesend"><a v-if="vcodetime==0" href="#" @click="getvcode">{{$common.dicword('sendcode')}}</a><span v-if="vcodetime>0">{{vcodetime}}{{$common.dicword('sendcodewait')}}</span></div></dd>

            <dd class="remeber"><el-checkbox v-model="logininfo.flag" :true-label="1" :false-label="0">{{wtype==3?$common.dicword('agreewith'):$common.dicword('rememberme')}}<router-link v-if="wtype==3" to="/terms">{{$common.dicword('terms')}}</router-link> </el-checkbox></dd>
            <dd class="btn"><a href="#" @click="login">{{wtype==3?issubmit?$common.dicword('reging'):$common.dicword('reg'):issubmit?$common.dicword('logining'):$common.dicword('login')}}</a></dd>
            <dd class="link"><a href="#" v-if="wtype!=1" @click="updatepoptype(1)"><i class="iconfont icon-zhanghaoguanli"></i>{{$common.dicword('loginbyusername')}}</a><a href="#" v-if="wtype!=2" @click="updatepoptype(2)"><i class="iconfont icon-shouji"></i>{{$common.dicword('loginbymobile')}}</a><a href="#" v-if="wtype!=3" @click="updatepoptype(3)"><i class="iconfont icon-zhuce"></i>{{$common.dicword('loginsignup')}}</a></dd>
        </dl>
        <Vcode :show="showvcode"
               :img-num="3"
               title="手动小图片到正确位置"
               @success="vcodesuccess"
               @close="showvcode = false" style="z-index:9999" />
    </div>
</template>

<script>
    import Vcode from 'vue-puzzle-vcode';

    export default {
        name: 'login',
        components: {
            Vcode
        },
        data() {
            return {
                'logininfo': {
                    'username': '',
                    'pwd': '',
                    'vcode': '',
                    'flag': 0
                },
                'iserrusername': false,
                'iserrpwd': false,
                'iserrvcode': false,
                'vcodetime': 0,
                'issubmit': false,
                'myinterval': '',
                'vcodeerror': 0,
                showvcode: false
            }
        },
        props: {
            poptype: {
                type: Number,
                default: 1
            }
        },
        computed: {
            wtype: function () {
                let v = this.poptype;
                if (v > 100) {
                    v = v - 100;
                }
                return v;
            },
            gourl: function () {
                return this.poptype > 100 ? '/tp' : '/member';
            }
        },
        mounted() {
            let vm = this;
            this.myinterval = window.setInterval(function () {
                if (vm.vcodetime > 0) {
                    vm.vcodetime--;
                }
            }, 1000);

            document.addEventListener('keyup', (e) => {
                var keycode = document.all ? window.event.keyCode : e.which;
                if (keycode == 13) {
                    this.login();
                }
            });

            this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });//清除验证码
        },
        methods: {

            updatepoptype: function (v) {
                this.logininfo.username = '';
                this.logininfo.pwd = '';
                this.logininfo.flag = v == 2 ? 1 : 0;
                this.iserrusername = false;
                this.iserrpwd = false;
                this.$emit('update:poptype', v);
            },
            vcodesuccess() {
                //this.$common.success('验证成功！正在发送短信')
                this.showvcode = false;
                this.sendSMS()
                // 调用短信接口
            },
            getvcode() {

                this.iserrusername = this.logininfo.username == '';
                if (!this.iserrusername) {
                    this.iserrusername = this.$common.validate(this.logininfo.username, "ismobile") == -1;
                }
                if (!this.iserrusername) {
                    this.showvcode = true;
                }
            },
            sendSMS() {
                let jsondata = {
                    'postdata': {
                        'api': 'member', 'act': 'vcodeget', "data": { "t": this.wtype == 3 ? 1 : 0 }, "mobile": this.logininfo.username
                    }, 'msg': ''
                };
                this.$common.post(jsondata, () => {
                    this.vcodetime = 60;
                    this.vcodeerror = 0;
                });
            },
            login() {

                this.iserrusername = this.logininfo.username == '';
                this.iserrpwd = this.logininfo.pwd == '';
                this.iserrvcode = this.logininfo.vcode == '';
                let isagree = this.wtype == 3 ? this.logininfo.flag == 1 : true;
                if (isagree) {
                    if (this.vcodeerror < 5) {
                        let isallow = this.wtype == 1 ? ((!this.iserrusername) && (!this.iserrpwd)) : ((!this.iserrusername) && (!this.iserrvcode))
                        if (isallow) {
                            this.issubmit = true;
                            let jsondata = {
                                'postdata': {
                                    'api': 'member', 'act': this.wtype == 3 ? 'reg' : 'login', "data": this.logininfo, "mobile": this.wtype == 1 ? '' : this.logininfo.username
                                }, 'msg': ''
                            };
                            this.$common.post(jsondata, (res) => {
                                this.$store.dispatch('setislogin', 1);
                                this.$store.dispatch('setmemlev', res.lev);
                                window.location = this.gourl;
                                //this.$router.push('/member');
                                this.$emit('hidepop');
                            }, () => {
                                this.issubmit = false;
                            });
                            if (this.wtype != 1) {
                                this.vcodeerror++;
                            }

                        }
                    }
                    else {
                        this.$common.fetch({ 'act': 'smscodeclear', 'msg': '', 'isautoback': false }, () => { });
                        this.$common.alert('验证码已失效，请重新获取验证码！');
                    }

                }
                else {
                    this.$common.alert('erragreeterm');
                }

            }

        },
        beforeDestroy() {
            window.clearInterval(this.myinterval);
            document.removeEventListener('keyup', () => { return; });
        }
    };
</script>
